import { Avatar } from "@rawa/ui/Avatar"
import { ListingCard, ListingCardSection } from "./ListingCard"

type Props = {
  firstName: string
  onClick: () => void
}

export function ParticipantButton({ firstName, onClick }: Props) {
  return (
    <ListingCard onClick={onClick}>
      <ListingCardSection tag="Session Participant">
        <Avatar name={firstName} />
        <span>Participant: {firstName}</span>
      </ListingCardSection>
    </ListingCard>
  )
}
